const SET_SELFTEST_PROMO_CODE = (state, code) => {
  state.selftestPromoCode = code;
};

export default {
  SET_SELFTEST_PROMO_CODE,
};
